import { merge } from './merge';
export function resolvePayload(payload) {
  return (Array.isArray(payload) ? payload : []).reduce(function (acc, curr) {
    acc.tags = merge(acc.tags, curr && curr.tags);
    return acc;
  }, {
    tags: []
  });
}